/**
 * React Query hook for fetching corporate actions.
 */

import { useQuery } from '@tanstack/react-query';
import { getCorporateActions } from '../../tradesApi';
import type { SplitConsolidateResponse } from '../../tradesApi';

interface UseCorporateActionsParams {
  positionId?: number;
  enabled?: boolean;
}

export function useCorporateActions(params?: UseCorporateActionsParams) {
  const { positionId, enabled = true } = params || {};

  return useQuery<SplitConsolidateResponse[]>({
    queryKey: ['corporateActions', positionId],
    queryFn: () => getCorporateActions(positionId),
    enabled,
  });
}
